import React from 'react';

import Loader from './Loader';

export default ({ isLoading, children }) => (
  <div className="LoaderWrapper">
    {isLoading ? <Loader size={0.215} /> : children}
  </div>
);
